import subpixel from '../util/canvasSubpixelOffset';
import LineTool from './LineTool';

/** Rectangle tool */
export default class RectLineTool extends LineTool {
	_getDefaultParams() {
		return {
			id: 'rectangle',
			name: 'Rectangle',
			style: this.core.getStyle('tool.rectangle')
		};
	}

	/** Define hitbox to be four edges of rectangle */
	isWithin(mousePanel) {
		const handles = this.handle;
		const hitboxSize = 10;
		const halfSize = hitboxSize / 2;

		if (handles.length === 2) {
			const coords = [handles[0].getCoords(), handles[1].getCoords()];

			if (!coords[0] || !coords[1]) {
				return false;
			}

			// create a hitbox for each edge of the rectangle
			const boundingBox = {
				x: Math.min(coords[0][0], coords[1][0]),
				y: Math.min(coords[0][1], coords[1][1]),
				width: Math.abs(coords[0][0] - coords[1][0]),
				height: Math.abs(coords[0][1] - coords[1][1])
			};
			const rectMouse = {
				x: mousePanel[0],
				y: mousePanel[1],
				width: 1,
				height: 1
			};
			const rectLeft = {
				x: boundingBox.x - halfSize,
				y: boundingBox.y,
				width: hitboxSize,
				height: boundingBox.height
			};
			const rectRight = {
				x: boundingBox.x + boundingBox.width - halfSize,
				y: boundingBox.y,
				width: hitboxSize,
				height: boundingBox.height
			};
			const rectTop = {
				x: boundingBox.x,
				y: boundingBox.y - halfSize,
				width: boundingBox.width,
				height: hitboxSize
			};
			const rectBottom = {
				x: boundingBox.x,
				y: boundingBox.y + boundingBox.height - halfSize,
				width: boundingBox.width,
				height: hitboxSize
			};

			// check intersection against all edges
			return (
				this.intersect(rectLeft, rectMouse) ||
				this.intersect(rectRight, rectMouse) ||
				this.intersect(rectTop, rectMouse) ||
				this.intersect(rectBottom, rectMouse)
			);
		}
	}

	render() {
		const coords = [this.handle[0].getCoords(), this.handle[1].getCoords()];
		if (!coords[0] || !coords[1]) return;

		const ctx = this.panel.rootToolContext;

		ctx.beginPath();

		ctx.strokeStyle = this.params.style.color;
		ctx.lineWidth = this.params.style.width;

		// rectangle
		subpixel.rect(
			ctx,
			coords[0][0],
			coords[0][1],
			coords[1][0] - coords[0][0],
			coords[1][1] - coords[0][1]
		);

		if (this.params.style.background.color) {
			ctx.fillStyle = this.params.style.background.color;
			ctx.fill();
		}

		ctx.stroke();

		if (this.state.selected || this.state.hover) {
			this.handle[0].render();
			this.handle[1].render();
		}

		this.panel.core.onToolRender(this);
	}
}
